import { render, staticRenderFns } from "./scrollRow.vue?vue&type=template&id=1b49e96a&scoped=true&"
import script from "./scrollRow.vue?vue&type=script&lang=js&"
export * from "./scrollRow.vue?vue&type=script&lang=js&"
import style0 from "./scrollRow.vue?vue&type=style&index=0&id=1b49e96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49e96a",
  null
  
)

export default component.exports